import { MethodEvaluation } from '../method-evaluation';

export class TransactionMethodEvaluationModalPayload {
  objectId: number;
  isPba: boolean;
  transactionId: number;
  transactionIdentifier: string;
  analysisName: string;
  srcJurisdictionIsoCode: string;
  destJurisdictionIsoCode: string;
  srcMethodNameExists: boolean;
  destMethodNameExists: boolean;
  methodEvaluation?: MethodEvaluation;
  compSearchId?: number;
  pliId?: number;
}
